<template>
  <div class="app-container">
    <el-row type="flex" class="row-bg" justify="space-around">
      <el-col :span="8" class="flex">
        <span>订单编号：</span>
        <el-input
          v-model="search.orderNum"
          placeholder="请输入订单编号"
        ></el-input>
      </el-col>
      <el-col :span="8" class="flex">
        <span>订单状态：</span>
        <el-select
          v-model="search.orderState"
          placeholder="请选择"
          clearable
          style="width:100%"
        >
          <el-option
            v-for="item in orderStateList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="8" class="flex">
        <span>期望上门时间：</span>
        <el-date-picker
          v-model="search.dateRange"
          type="daterange"
          range-separator="至"
          :default-time="['00:00:00', '23:59:59']"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :disabled="isEdit"
          style="width:100%"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="8" class="flex">
        <span>联系电话：</span>
        <el-input
          v-model="search.mobilePhone"
          placeholder="请输入手机号"
        ></el-input>
      </el-col>
    </el-row>
    <el-row type="flex" class="row-bg" justify="space-around">
      <el-col :span="8" class="flex">
        <span>下单时间：</span>
        <el-date-picker
          v-model="search.createdDateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          :default-time="['00:00:00', '23:59:59']"
          end-placeholder="结束日期"
          :disabled="isEdit"
          style="width:100%"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="8" class="flex">
        <span>省份：</span>
        <el-select
          v-model="search.provinceName"
          placeholder="请选择"
          clearable
          style="width:100%"
          @change="getTblCity"
        >
          <el-option
            v-for="item in provinceList"
            :key="item.sfid"
            :label="item.sfen"
            :value="item.sfen"
            style="width:100%"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="8" class="flex">
        <span>城市：</span>
        <el-select
          v-model="search.cityName"
          placeholder="请选择"
          clearable
          style="width:100%"
          :disabled="!search.provinceName"
        >
          <el-option
            v-for="item in cityList"
            :key="item.ciid"
            :label="item.city"
            :value="item.city"
            style="width:100%"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="8" class="flex">
        <span>回收品类：</span>
        <el-select
          v-model="search.productCategoryCode"
          placeholder="请选择"
          clearable
          style="width:100%"
        >
          <el-option
            v-for="item in goodsTypeList"
            :key="item.value"
            :label="item.spmc"
            :value="item.spid"
            style="width:100%"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row type="flex" class="row-bg" justify="end">
      <el-col :span="8" class="flex justify-end">
        <el-button type="primary" size="medium" @click="getList()">查询</el-button>
        <el-button size="medium" @click="resetForm()">重置</el-button>
        <el-button type="primary" size="medium"  @click="pushYx()">有闲有品批量推送</el-button>        <!-- <el-button size="medium" @click="exportDialogVisible = true">导出</el-button> -->
        <el-button type="primary" size="medium" @click="exportNormalData">导出</el-button>
      </el-col>
      <!-- <el-col :span="8" class="flex"></el-col> -->
    </el-row>

    <el-table ref="checktableData" :data="list" v-loading="listLoading" :reserve-selection="true" center @selection-change="handleSelectionChange" height="60vh">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="订单编号" min-width="150">
        <template slot-scope="scope">{{ scope.row.orderNum }}</template>
      </el-table-column>
      <el-table-column label="订单状态" min-width="100">
        <template slot-scope="scope">{{ scope.row.orderStateStr }}</template>
      </el-table-column>
      <el-table-column label="期望上门时间" min-width="220">
        <template slot-scope="scope">{{ scope.row.preferredArrivalTime | formatDateTimeDefault }}</template>
      </el-table-column>
      <el-table-column label="地址" min-width="200">
        <template slot-scope="scope">{{ scope.row.provinceName }}{{ scope.row.cityName }}{{ scope.row.districtName }}{{ scope.row.address }}</template>
      </el-table-column>
      <el-table-column label="联系电话" min-width="200">
        <template slot-scope="scope">{{ scope.row.mobilePhone }}</template>
      </el-table-column>
      <el-table-column label="估价品类" min-width="200" prop="productCategoryName"></el-table-column>
      <el-table-column label="姓名" min-width="200">
        <template slot-scope="scope">{{ scope.row.username }}</template>
      </el-table-column>
      <el-table-column label="下单时间" min-width="200">
        <template slot-scope="scope">
          {{ scope.row.createdDate | formatDateTimeDefault }}
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="170">
        <template slot-scope="scope">
          <el-button type="text" @click="goEdit(scope.row.orderNum)">
            查看
          </el-button>
          <el-button type="text" @click="exportGood(3, scope.row.orderNum)">
            导出
          </el-button>
          <el-button type="text" @click="delectUser(scope.row.orderNum)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="search.pageNum"
        :page-size="search.pageSize"
        :page-sizes="[10, 20, 30, 40, 50]"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data() {
    return {
      list: [],
      search: {
        orderNum: '', //用户编号
        orderNumList: '', //订单编号list
        orderState: '', // 订单状态
        preferredArrivalTimeStart: '', //期望上门开始时间
        preferredArrivalTimeEnd: '', //期望上门结束时间
        mobilePhone: '',
        productCategoryCode: '',
        provinceName: '',
        cityName: '',
        pageNum: 1,
        pageSize: 10,
        dateRange: [],
        createdDateRange: []
      },
      isEdit: false,
      listLoading: false,
      orderStateList: [
        // 1 待取件 2 已完成 3 已取消 4 已估价
        {
          label: '待取件',
          value: '1'
        },
        {
          label: '已完成',
          value: '2'
        },
        {
          label: '已取消',
          value: '3'
        }
      ],
      goodsTypeList: [],
      // 选中过的页码
      selectedPageNums: [],
      // 选中也所有的数据
      selectedAllData: [],
      // 是否全选中
      allChecked: false,
      allSelectedIds: [],
      unSelectedIds: [], // 所有未选中的id
      oldarr: [],
      arr: [],
      total: 0,
      exportDialogVisible: false,
      sourceList: [],
      provinceList: [],
      cityList: [],
      IdLish: []
    }
  },
  filters: {},
  async created() {
    await this.getTblSplbDalei()
    await this.getTblProvince()
    this.getList()
  },
  methods: {
    selectable(row, index) {
      return row.cityCode === '珠海市' && !row.yxypOrderNum && !row.yyzsOrderNum && row.orderStateStr === '待取件'
    },
    PushOrderLish(type) {
      if (!this.IdLish.length) {
        this.$message.error('请勾选订单')
        return
      }
      let params = {
        type: type,
        orderNums: this.IdLish
      }
      this.HttpService.post(`/autoapp-default-server-recovery/api/tblRecycleOrder/pushOrderManually`, params).then(res => {
        if (res.statusCode === 200) {
          this.$message.success('推单成功')
          this.getList()
        }
      })
    },
    pushOrder(value, type) {
      console.log(value, 'value')
      let arr = []
      if (typeof value === 'object') {
        arr.push(value.orderNum)
      } else {
      }
      let params = {
        type: type,
        orderNums: arr
      }
      this.HttpService.post(`/autoapp-default-server-recovery/api/tblRecycleOrder/pushOrderManually`, params).then(res => {
        if (res.statusCode === 200) {
          this.$message.success('推单成功')
          this.getList()
        }
      })
    },
    //推送到有闲有品
    pushYx(){
      if (!this.search.orderNumList.length) {
        this.$message.warning('请先勾选订单')
        return
      }
      this.HttpService.get(`/autoapp-default-server-recovery/api/association-recycle-order/pushOrderToYooXianYouPin?orderNums=${ this.search.orderNumList}`).then(res => {
        if (res.statusCode === 200) {
          this.$message.success('推单成功')
          this.getList()
        }
      })
    },
    handleSelectionChange(val) {
      this.search.orderNumList = val.map(item => item.orderNum)
    },
    getTblCity() {
      this.search.cityName = ''
      return this.HttpService.get(`/autoapp-default-server-recovery/api/tbl-city/getTblCity?sfen=${this.search.provinceName}`).then(res => {
        if (res.statusCode === 200) {
          this.cityList = res.data
        }
      })
    },
    getTblProvince() {
      this.search.cshi = ''
      return this.HttpService.get('/autoapp-default-server-recovery/api/tbl-province/getTblProvince').then(res => {
        if (res.statusCode === 200) {
          this.provinceList = res.data
        }
      })
    },
    getTblSplbDalei() {

      return this.HttpService.get('/autoapp-default-server-recovery/api/tbl-splb-dalei/getTblSplbDalei?flag=1').then(res => {
        if (res.statusCode === 200) {
          this.goodsTypeList = res.data
        }
      })
    },
    // 订单来源字典
    getSourceList() {
      return this.HttpService.get('/autoapp-default-server-recovery/api/tblRecycleSource/list').then(res => {
        if (res.statusCode === 200) {
          console.log('getSourceList>>>', res.data)
          this.sourceList = res.data
        }
      })
    },
    paramsData() {
      let { orderNum, dateRange, mobilePhone, orderState, productCategoryCode, createdDateRange, provinceName, cityName } = this.search || ''
      let params = {
        provinceName: provinceName,
        cityName: cityName,
        orderNum: orderNum, //订单编号
        mobilePhone: mobilePhone, //注册手机号
        orderState: orderState, //订单状态：0冻结，1可用
        orderStateAll: [1, 2, 3],
        preferredArrivalTimeStart: dateRange[0],
        preferredArrivalTimeEnd: dateRange[1],
        createdDateStart: createdDateRange[0],
        createdDateEnd: createdDateRange[1],
        productCategoryCode: productCategoryCode
      }
      return params
    },
    getList() {
      let params = {
        pageSize: this.search.pageSize,
        pageNum: this.search.pageNum
      }
      this.list = []
      this.listLoading = true
      this.HttpService.post('/autoapp-default-server-recovery/api/association-recycle-order/page', this.global.clearEmptyParam(Object.assign(this.paramsData(), params))).then(
        res => {
          if (res.statusCode === 200) this.total = res.data.total
          if (res.data.length === 0) {
            this.$dialog({
              title: '温馨提示',
              content: '未查询到结果!',
              footBtn: false,
              width: '20%',
              dialogType: 'sighicon'
            })
          } else {
            this.arr = []
            this.list = res.data.records
            this.listLoading = false

          }
        }
      )
    },
    getImg(element, objectName) {
      return new Promise((resolve, reject) => {
        this.axios({
          url: process.env.BASE_API + `/autoapp-default-server-recovery/api/OSS/generatePresignedUrlStr?objectName=${objectName}`,
          method: 'GET',
          headers: {
            // 设置请求头
            Authorization: this.$store.getters.token
          }
        }).then(res => {
          element.goodsImage = res.data.data
          this.arr.push(element)
          resolve()
        })
      })
    },
    exportGood(type, id) {
      if (type === 3) {
        let params = {
          orderNum: id,
          commodityNum: ''
        }
        this.global.exportExcel(`/autoapp-default-server-recovery/api/association-recycle-order/exportEstimationOrder`, params, '回收订单明细表').catch(res => {
          let blob = new Blob([res.response.data], {
            type: 'application/json'
          })
          var blobReader = new Response(blob).json()
          blobReader.then(res => {
            this.$message.error(res.message)
          })
        })
      } else {
        this.export()
      }
    },
    // 导出普通
    exportNormalData() {
      this.exportGood(1)
    },
    export() {
      let params = {
        pageSize: this.search.pageSize,
        pageNum: this.search.pageNum
      }
      if (this.search.orderNumList.length > 0) {
        params.orderNumList = this.search.orderNumList
      }
      let title = '回收订单明细'
      this.global
        .exportExcel('/autoapp-default-server-recovery/api/association-recycle-order/exportEstimationOrder', Object.assign(this.paramsData(), params), `${title}明细表`)
        .then(res => {
          console.log('res', res)
        })
        .catch(res => {
          let blob = new Blob([res.response.data], {
            type: 'application/json'
          })
          var blobReader = new Response(blob).json()
          blobReader.then(res => {
            this.$message.error(res.message)
          })
        })
    },
    handleSizeChange(val) {
      this.search.pageNum = 1
      this.search.pageSize = val
      this.getList()
    },
    handleCurrentChange() {
      this.getList()
    },
    resetForm(formName) {
      this.search = this.$options.data().search
      // this.getList()
    },
    delectUser(id) {
      this.$dialog({
        title: '温馨提示',
        content: '是否要删除，删除后不可以恢复！',
        cancel_buttton: '否',
        ok_buttton: '是',
        width: '400px',
        footBtn: 'card',
        dialogType: 'delete',
        onOk: () => {
          if (id)
            this.HttpService.post(`/autoapp-default-server-recovery/api/tblRecycleOrder/delOrder/${id}`).then(res => {
              if (res.statusCode === 200) this.$message.success('删除成功')
              this.getList()
            })
        },
        onCancel: () => {
          console.log('cancel')
        }
      })
    },
    goEdit(orderNum) {
      this.$router.push({
        path: '/order/valuationEdit',
        query: {
          orderNum: orderNum
        }
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.goodsStyle {
  display: flex;
  align-items: center;
}
.flex {
  display: flex;
  align-items: center;
  // margin: 0 20px;
  padding: 0 20px;
  span {
    min-width: 130px;
  }
}

.justify-end {
  justify-content: flex-end;
}

.row-bg {
  margin-bottom: 15px;
}
.btnBox {
  margin-bottom: 20px;
}
.BTNList {
}
</style>



// WEBPACK FOOTER //
// src/views/order/valuation.vue